module.exports = __webpack_public_path__ + "img/bakingLesson.70f270cd.jpg";